"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AssignBedFilterDto {
}
exports.AssignBedFilterDto = AssignBedFilterDto;
